import { Box, Button, Drawer, Divider, Grid, IconButton } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Cookies, withCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import { rem, isWeb } from "assets/js/common";
import { Link } from "react-router-dom";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import AlertConfirm from "./alert-confirm";
import paths from "deepdash/es/paths";
import Mart from "components/left/mart";
import Market from "components/left/market";
import jwt_decode from "jwt-decode";
import { loadLeftAction } from "redux/reducers/left";
import CacheRoute, {
  dropByCacheKey,
  getCachingKeys,
  clearCache,
} from "react-router-cache-route";
import { getAppData } from "assets/js/apphandle";

const cookies = new Cookies();

function Menu(props) {
  const { sidebar, handleSidebarClose } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [notiListUnseenCount, setNotiListUnseenCount] = useState(0);
  const [redirectPath, setRedirectPath] = useState("");
  const [clublist, setClubList] = useState([]);
  const token = cookies.get("X-AUTH-TOKEN");
  const myDecodedToken = token ? jwt_decode(token) : "";

  const favInfo = cookies.get("favInfo");

  const { mainSide } = useSelector((state) => state.left);

  // const handleSidebarClose = () => {
  //   props.setSidebar(false);
  //   dropByCacheKey(location.pathname);
  // };

  const goLogin = () => {
    handleAlertClose();
    handleSidebarClose();
    history.push(redirectPath);
  };

  const handleAlertOpen = (path) => {
    setRedirectPath(path);
    setOpen(true);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const goPage = (path) => {
    if (token) {
      handleSidebarClose();
      history.push(path);
    } else {
      handleAlertOpen(path);
    }
  };

  const getNotiListUnseenCount = () => {
    window.appNotiListUnseenCount = (os, count) => {
      setNotiListUnseenCount(count);
    };
    if (window.Android) {
      window.Android.getNotiListUnseenCount();
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      // Call iOS interface
      var message = {
        command: "getNotiListUnseenCount",
      };
      window.webkit.messageHandlers.ios.postMessage(message);
    }
  };

  useEffect(() => {
    if (sidebar) getNotiListUnseenCount();
  }, [sidebar]);

  return (
    <>
      <Drawer
        anchor="right"
        open={sidebar}
        onClose={handleSidebarClose}
        className="sidebar"
      >
        {myDecodedToken ? (
          <Box className="category-box header">
            <IconButton
              aria-label="close"
              className="btn-home"
              onClick={() => {
                handleSidebarClose();
                history.replace("/");
              }}
            >
              <span className="hidden">홈</span>
            </IconButton>
            <Link
              className="my-info"
              to={"/mypage"}
              onClick={handleSidebarClose}
            >
              {myDecodedToken.nm} 회원님
              {/* {mainSide.point}P */}
            </Link>
            <IconButton
              aria-label="close"
              className="btn-close"
              onClick={handleSidebarClose}
            >
              <span className="hidden">닫기</span>
            </IconButton>
            <IconButton
              aria-label="push"
              className={
                notiListUnseenCount > 0 ? "btn-push-on" : "btn-push-off"
              }
              onClick={() => {
                goPage("/push");
              }}
            >
              <span className="hidden">알림함</span>
            </IconButton>
          </Box>
        ) : (
          <Box className="category-box header">
            <IconButton
              aria-label="close"
              className="btn-home"
              onClick={() => {
                handleSidebarClose();
                history.replace("/");
              }}
            >
              <span className="hidden">홈</span>
            </IconButton>
            <Link className="login" to={"/login"} onClick={handleSidebarClose}>
              로그인
            </Link>
            하고 다양한 혜택을 받으세요
            <IconButton
              aria-label="close"
              className="btn-close"
              onClick={handleSidebarClose}
            >
              <span className="hidden">닫기</span>
            </IconButton>
          </Box>
        )}
        {favInfo && favInfo.visibleTp == 2 ? (
          <Market
            handleSidebarClose={handleSidebarClose}
            open={open}
            handleAlertClose={handleAlertClose}
            goPage={goPage}
            mainSide={mainSide}
            sidebar={sidebar}
          />
        ) : (
          <Mart
            handleSidebarClose={handleSidebarClose}
            open={open}
            handleAlertClose={handleAlertClose}
            goPage={goPage}
            sidebar={sidebar}
          />
        )}

        <div className="foot-actions">
          <Divider />
          <Grid container spacing={1}>
            <Grid item>
              <Link to={"/notice/list"} onClick={handleSidebarClose}>
                공지사항
              </Link>
            </Grid>
            <Grid item>
              <Link to={"/customer"} onClick={handleSidebarClose}>
                고객센터
              </Link>
            </Grid>
            <Grid item>
              <Button
                onClick={() => {
                  goPage("/setting");
                }}
              >
                설정
              </Button>
            </Grid>
          </Grid>
        </div>
      </Drawer>
      <AlertConfirm
        open={open}
        handleAlertClose={handleAlertClose}
        text={`로그인이 필요한 서비스입니다.<br/>로그인 하시겠습니까?`}
        action={goLogin}
      />
    </>
  );
}

export default withRouter(withCookies(Menu));
